import { createContext, useContext } from "react";
/* istanbul ignore next: no logic in this factory! */

/**
 * Create context relevant objects to use within React.
 *
 * @param object
 * @returns
 */

function createContextFactory(object) {
  /**
   * MobX stores collection
   */
  var StoreContext = /*#__PURE__*/createContext(object);
  /**
   * MobX HOC to get the context via hook.
   *
   * @param children
   */

  var StoreProvider = function StoreProvider(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React.createElement(StoreContext.Provider, {
      value: object
    }, children);
  };
  /**
   * Get all the MobX stores via a single hook.
   */


  var useStores = function useStores() {
    return useContext(StoreContext);
  };

  return {
    StoreContext: StoreContext,
    StoreProvider: StoreProvider,
    useStores: useStores
  };
}

export { createContextFactory };